// components/InfluencerBrandlyPromote/InfluencerBrandlyPromote.jsx
import React from "react";

// Promote section icons
import highDemandIcon from "../../assets/InfluencerPageGraphics/upblue.png";
import cookieLifeIcon from "../../assets/InfluencerPageGraphics/calblue.png";
import recurringIcon from "../../assets/InfluencerPageGraphics/dollarblue.png";
import contentKitIcon from "../../assets/InfluencerPageGraphics/giftblue.png";
import trustedIcon from "../../assets/InfluencerPageGraphics/handblue.png";

import "./InfluencerBrandlyPromote.css"; // Optional: move relevant CSS here

const promotionPoints = [
  {
    icon: highDemandIcon,
    title: "High-Demand Product",
    text: "Personal branding is booming—Brandly helps people stand out and win trust.",
  },
  {
    icon: cookieLifeIcon,
    title: "6-Month Cookie Life",
    text: "Long referral window means better conversions and more earnings.",
  },
  {
    icon: recurringIcon,
    title: "Recurring 25% Commission",
    text: "Earn monthly, not just once. Get paid as long as they stay.",
    center: true,
  },
  {
    icon: contentKitIcon,
    title: "Ready-to-Use Content Kit",
    text: "Plug-and-play email copy, banners, social post templates—everything you need.",
  },
  {
    icon: trustedIcon,
    title: "Trusted by Founders, Creators & Coaches",
    text: "A tool people love—and love to share.",
  },
];

const InfluencerBrandlyPromote = () => {
  return (
    <section className="influencer-page-promote">
      <h2>
        Why <span className="influencer-page-text-blue">Promote</span> Brandly?
      </h2>
      <div className="influencer-page-promote-grid">
        {promotionPoints.map((item, index) => (
          <div className="promo-pill-background" key={index}>
            <div
              className={`influencer-promo-pill ${item.center ? "center" : ""}`}
            >
              <div className="promo-pill-content">
                <div className="promo-pill-icon">
                  <img src={item.icon} alt={item.title} />
                </div>
                <div className="promo-pill-text">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default InfluencerBrandlyPromote;
